import { Icon } from "@for-it/web-lib";
import { ADMIN_CONTACT } from "../environment.ts";

export default function IconContact() {
    return (
        <div className="fixed bottom-20 right-5 z-50">
            <a
                href={`${ADMIN_CONTACT}`}
                target="_blank"
                rel="noreferrer"
                className="bg-[#9C9C9A] hover:bg-gray-500 text-white p-2 sm:p-3 rounded-full shadow-lg flex items-center justify-center transition duration-300 cursor-pointer"
                aria-label="Contáctenos"
            >
                <Icon name="bx-mail-send" className="text-lg w-7 text-center" />
            </a>
        </div>
    );
}
